import LostFoundFilters from "@/components/lost-found/LostFoundFilters";
import LostFoundViewSwitcher from "@/components/lost-found/LostFoundViewSwitcher";
import { LostItem } from "@/types";

interface LostFoundBodyProps {
  searchQuery: string;
  location: string;
  status: string;
  view: "list" | "grid";
  onSearch: (query: string) => void;
  onLocationChange: (loc: string) => void;
  onStatusChange: (status: string) => void;
  onReset: () => void;
  onToggleView: (view: "list" | "grid") => void;
  onNew: () => void;
  isMobile: boolean;
  items: LostItem[];
  handlers: {
    onDeliver: (item: LostItem) => void;
    onUndo: (item: LostItem) => void;
    onEdit: (item: LostItem) => void;
    onDelete: (item: LostItem) => void;
    onDiscard: (item: LostItem) => void;
    openTimeline: (item: LostItem) => void;
    openInfo: (item: LostItem) => void;
  };
  setSelectedItem: (item: LostItem) => void;
  setDeleteDialogOpen: (open: boolean) => void;
}

const LostFoundBody = ({
  searchQuery,
  location,
  status,
  view,
  onSearch,
  onLocationChange,
  onStatusChange,
  onReset,
  onToggleView,
  onNew,
  isMobile,
  items,
  handlers,
  setSelectedItem,
  setDeleteDialogOpen
}: LostFoundBodyProps) => {
  // Filtering logic
  const filteredItems = items.filter(item => {
    // Location filter
    const loc = (item as any).location;
    const locationMatch = !location || location === 'All Locations' || loc === location;
    // Status filter
    const statusMatch = !status || status === 'All Statuses' || item.status === status;
    // Search filter
    const searchMatch = !searchQuery || item.description.toLowerCase().includes(searchQuery.toLowerCase());
    return locationMatch && statusMatch && searchMatch;
  });

  return (
    <main className="container mx-auto p-4">
      <LostFoundFilters
        searchQuery={searchQuery}
        location={location}
        status={status}
        view={view}
        onSearch={onSearch}
        onLocationChange={onLocationChange}
        onStatusChange={onStatusChange}
        onReset={onReset}
        onToggleView={onToggleView}
        onNew={onNew}
        isMobile={isMobile}
        items={filteredItems}
        allItems={items}
      />
      <LostFoundViewSwitcher
        view={view}
        items={filteredItems}
        handlers={handlers}
        setSelectedItem={setSelectedItem}
        setDeleteDialogOpen={setDeleteDialogOpen}
      />
    </main>
  );
};

export default LostFoundBody;
